const PAYMENT_STATUS_ELEMENT_ID = 'payment-status'
const WAIT_TIME = 3000

export const dynamicDisplayRedirect = (returnUrl?: string | null) => {
  const urlParams = new URLSearchParams(window.location.search)

  const from3ds = urlParams.get('3ds')

  if (returnUrl !== null && returnUrl !== undefined && returnUrl !== '') {
    if (from3ds) {
      onPaymentStatusElementPresent(() => {
        setTimeout(() => {
            window.location.href = returnUrl
        }, WAIT_TIME)
      })

        return 'none'
    }

    return 'block'
  }

  return 'none'
}

const onPaymentStatusElementPresent = (callback: () => void) => {
  // Check if element is already present
  if (document.getElementById(PAYMENT_STATUS_ELEMENT_ID)) {
    callback()
    return
  }

  // Create a MutationObserver to watch for the element
  const observer = new MutationObserver((mutations, obs) => {
    if (document.getElementById(PAYMENT_STATUS_ELEMENT_ID)) {
      callback()
      obs.disconnect()
    }
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })
}
